import React from 'react';
import { shape, bool, instanceOf, func } from 'prop-types';

import CTHeader from './CTHeader';
import CTTable from './CTTable';

const CampaignTargets = ({
  definition,
  setSelectedTargets,
  updateQueryParams,
  loadMore,
  setView,
  handleAction,
  internalAdmin
}) => {
  return (
    <div className="de--campaign--root de--flex-col de--flex-col-1">
      <CTHeader
        definition={definition}
        updateQueryParams={updateQueryParams}
        handleAction={handleAction}
        internalAdmin={internalAdmin}
        setView={setView}
      />
      <CTTable
        definition={definition}
        setSelectedTargets={setSelectedTargets}
        updateQueryParams={updateQueryParams}
        loadMore={loadMore}
        setView={setView}
        handleAction={handleAction}
      />
    </div>
  );
};

CampaignTargets.propTypes = {
  definition: shape({
    loading: bool,
    error: bool,
    data: instanceOf(Array),
  }),
  setSelectedTargets: func,
  updateQueryParams: func,
  loadMore: func,
  setView: func,
  handleAction: func,
  internalAdmin: bool
};

CampaignTargets.defaultProps = {
  definition: {
    loading: true,
    error: false,
    data: [],
  },
};

export default CampaignTargets;
